export default __webpack_public_path__ + "static/media/google.0ff45cb6.png";